/* Hardtuned cross-store routing. Shopify Markets owns localization within each store.
 * Staff: ?ht_geo=off (remembered 30 days); ?ht_geo=on restores automatic routing.
 * Explicit store: ?ht_store=au or ?ht_store=us; ?ht_store=auto clears the choice.
 * Failed/unknown lookup stays put. Shared 60-second hop guard prevents bouncing.
 */
(function () {
  'use strict';
  const store = document.currentScript && document.currentScript.dataset.htStore;
  const hosts = { au: ['au.hardtunedstore.com', 'nz.hardtunedstore.com'], us: ['us.hardtunedstore.com', 'shop.hardtunedstore.com', 'uk.hardtunedstore.com', 'eu.hardtunedstore.com', 'ca.hardtunedstore.com'] };
  if (!hosts[store] || !hosts[store].includes(location.hostname)) return;
  const url = new URL(location.href);
  const params = url.searchParams;
  const cookie = name => document.cookie.split(';').map(s => s.trim()).find(s => s.startsWith(name + '='))?.slice(name.length + 1) || '';
  const remember = (name, value, seconds) => { document.cookie = name + '=' + value + '; Max-Age=' + seconds + '; Path=/; Domain=hardtunedstore.com; SameSite=Lax; Secure'; };
  if (window.top !== window.self || window.Shopify?.designMode || /shopify\.com|myshopify\.com/.test(document.referrer) || params.has('preview_theme_id') || params.has('preview_key') || params.has('_fd') || cookie('preview_theme_id')) return;
  if (params.get('ht_geo') === 'off') { remember('ht_geo', 'off', 2592000); return; }
  if (params.get('ht_geo') === 'on') remember('ht_geo', '', 0);
  else if (cookie('ht_geo') === 'off') return;
  if (/^\/(?:cart|checkout|checkouts|account|accounts|customer_authentication|admin|challenge|apps)(?:\/|$)/i.test(url.pathname)) return;
  if (/bot|crawl|spider|slurp|facebookexternalhit|meta-external|headless|lighthouse|pagespeed|google-inspectiontool/i.test(navigator.userAgent)) return;
  const explicit = params.get('ht_store');
  if (explicit === 'auto') remember('ht_store', '', 0);
  else if (explicit === 'au' || explicit === 'us') remember('ht_store', explicit, 2592000);
  const preference = explicit === 'auto' ? '' : ((explicit === 'au' || explicit === 'us') ? explicit : cookie('ht_store'));
  function route(destination) {
    if (destination === store || (!explicit && cookie('ht_geo_hop'))) return;
    remember('ht_geo_hop', '1', 60);
    url.hostname = destination === 'au' ? 'au.hardtunedstore.com' : 'us.hardtunedstore.com';
    url.protocol = 'https:';
    url.port = '';
    location.replace(url.href);
  }
  if (preference === 'au' || preference === 'us') { route(preference); return; }
  function apply(data) {
    const country = String(data?.countryCode || '').toUpperCase();
    if (!/^[A-Z]{2}$/.test(country) || country === 'XX' || country === 'ZZ') return;
    if (document.body) document.body.classList.add('country-' + country.toLowerCase());
    route(['AU', 'NZ', 'JP'].includes(country) ? 'au' : 'us');
  }
  try {
    const savedAt = Number(localStorage.getItem('ip-timeout'));
    const cached = localStorage.getItem('ip-lookup');
    if (cached && savedAt > 0 && Date.now() - savedAt >= 0 && Date.now() - savedAt < 86400000) { apply(JSON.parse(cached)); return; }
  } catch (_) { /* Storage may be unavailable; continue with a bounded lookup. */ }
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 3000);
  fetch("https://extreme-ip-lookup.com/json/?key=cuVRuUx4xi2MdrFvOs6r", { signal: controller.signal, credentials: 'omit' })
    .then(response => { if (!response.ok) throw new Error('Geo lookup unavailable'); return response.json(); })
    .then(data => { try { localStorage.setItem('ip-lookup', JSON.stringify(data)); localStorage.setItem('ip-timeout', String(Date.now())); } catch (_) {} apply(data); })
    .catch(() => { /* Never redirect when location cannot be determined. */ })
    .finally(() => clearTimeout(timeout));
})();
